var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"star-rating"},[_c('h4',[_vm._v(" "+_vm._s(_vm.translations.customer_reviews.average_rating)+": "),_c('StarRating',{attrs:{"rating":_vm.ratings.average_rating,"read-only":true,"star-size":40,"rounded-corners":true,"text-class":"star-rating__number"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }